<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <div
      class="doc-paper preview keirekisho"
      :id="idPrefix + 'preview-page-01'"
    >
      <div class="keirekisho-wapper">
        <div class="keirekisho-header">
          <div
            class="flex"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <h1 class="title" style="border-bottom: none">スキルシート</h1>
            <div
              class="date data text-right"
              :data-highlight="highlightMessage"
              @click="goCardTo('create-date')"
              :class="highLightClass('create-date')"
              style="margin-top: 0"
            >
              <span v-html="formatedCreateDate"></span>
            </div>
          </div>

          <div
            class="keirekisho-content"
            style="border: 2px solid #000; margin-top: 10px"
          >
            <div
              class="flex"
              style="display: flex; border-bottom: 1px solid #000"
              @click="goCardTo('profile')"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 150px;
                  border-right: 1px solid #000;
                "
              >
                ふりがな
              </div>
              <div
                style="
                  text-align: left;
                  padding: 0 10px;
                  width: calc(100% - 150px);
                  height: 24px;
                  overflow: hidden;
                "
              >
                {{ basicData.lastNameFurigana }}&emsp;{{
                  basicData.firstNameFurigana
                }}
              </div>
            </div>
            <div
              class="flex"
              style="display: flex; border-bottom: 1px solid #000"
              @click="goCardTo('profile')"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 150px;
                  border-right: 1px solid #000;
                "
              >
                名前
              </div>
              <div
                style="
                  text-align: left;
                  padding: 0 10px;
                  width: calc(100% - 150px);
                  height: 24px;
                  overflow: hidden;
                "
              >
                {{ basicData.lastName }}&emsp;{{ basicData.firstName }}
              </div>
            </div>
            <div
              class="flex"
              style="display: flex; border-bottom: 1px solid #000"
              @click="goCardTo('skills-to-use')"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 150px;
                  border-right: 1px solid #000;
                "
              >
                スキル
              </div>
              <div
                style="
                  text-align: left;
                  padding: 0 10px;
                  width: calc(100% - 150px);
                  height: 24px;
                  overflow: hidden;
                "
              >
                {{ formatData.skills }}
              </div>
            </div>
            <div
              class="flex"
              style="display: flex; border-bottom: 1px solid #000"
              @click="goCardTo('intelligence')"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 150px;
                  border-right: 1px solid #000;
                "
              >
                活かせる経験・知識
              </div>
              <div
                style="
                  text-align: left;
                  padding: 0 10px;
                  width: calc(100% - 150px);
                "
              >
                {{ formatData.intelligence }}
              </div>
            </div>
            <div
              class="flex"
              style="display: flex"
              @click="goCardTo('other-skills')"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 150px;
                  border-right: 1px solid #000;
                "
              >
                その他
              </div>
              <div
                style="
                  text-align: left;
                  padding: 0 10px;
                  width: calc(100% - 150px);
                "
              >
                {{ formatData.otherskills }}
              </div>
            </div>
          </div>
          <!--<div class="data text-right"
               :data-highlight="highlightMessage"
               @click="goCardTo('profile')"
               :class="highLightClass('profile')">
          <span class="name">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</span>
        </div>-->
        </div>
        <div class="keirekisho-content">
          <!--<h2 v-if="formatData.jobHistories && formatData.jobHistories.length" id="job-history">職務経歴</h2>-->
          <div
            class="job-history"
            :data-highlight="highlightMessage"
            @click="goCardTo('job-history')"
            :class="highLightClass('job-history')"
          >
            <div v-for="item in formatData.jobHistories" :key="item.uuid">
              <h3
                v-if="
                  item.companyName ||
                  item.startYear ||
                  item.startMonth ||
                  item.endYear ||
                  item.endMonth
                "
                class="company-name"
                :style="formatData.selFontStyle"
              >
                {{ item.companyName }}
                <span
                  v-if="item.isContinuing && item.startYear && item.startMonth"
                  >{{ item.startYear }}年 {{ item.startMonth }}月 〜
                  在職中</span
                >
                <span
                  v-else-if="
                    item.isContinuing && item.startYear && !item.startMonth
                  "
                  >{{ item.startYear }}年 〜 在職中</span
                >
                <span
                  v-else-if="
                    item.isContinuing && !item.startYear && item.startMonth
                  "
                  >{{ item.startMonth }}月 〜 在職中</span
                >
                <span
                  v-else-if="
                    item.isContinuing && !item.startYear && !item.startMonth
                  "
                  >在職中</span
                >
                <span v-else
                  ><template v-if="item.startYear"
                    >{{ item.startYear }}年</template
                  >
                  <template v-if="item.startMonth"
                    >{{ item.startMonth }}月</template
                  >
                  <template v-if="item.endYear || item.endMonth">〜</template>
                  <template v-if="item.endYear">{{ item.endYear }}年</template>
                  <template v-if="item.endMonth"
                    >{{ item.endMonth }}月</template
                  ></span
                >
              </h3>

              <!--<div class="organization" v-if="item.businessArea || item.numberOfEmployees || item.capitalStock" :style="formatData.selFontStyle">
              <p v-if="item.businessArea"><pre :style="formatData.selFontStyle">事業内容：{{ item.businessArea}}</pre></p>
              <p v-if="item.capitalStock && item.numberOfEmployees">資本金：{{ item.capitalStock }}万円、従業員数：{{ item.numberOfEmployees }}名</p>
              <p v-else-if="item.capitalStock && !item.numberOfEmployees">資本金：{{ item.capitalStock }}万円</p>
              <p v-else-if="!item.capitalStock && item.numberOfEmployees">従業員数：{{ item.numberOfEmployees }}名</p>
            </div>-->

              <div
                v-for="(project, index) in item.projects"
                :key="index"
                :style="formatData.selFontStyle"
                style="margin-bottom: 20px"
              >
                <h5
                  v-if="
                    project.projectTitle ||
                    project.startYear ||
                    project.startMonth ||
                    project.endYear ||
                    project.endMonth
                  "
                >
                  {{ project.projectTitle
                  }}<span
                    ><template v-if="project.startYear"
                      >{{ project.startYear }}年</template
                    >
                    <template v-if="project.startMonth"
                      >{{ project.startMonth }}月</template
                    >
                    <template v-if="project.endYear || project.endMonth"
                      >〜</template
                    >
                    <template v-if="project.endYear"
                      >{{ project.endYear }}年</template
                    >
                    <template v-if="project.endMonth"
                      >{{ project.endMonth }}月</template
                    ></span
                  >
                </h5>
                <pre
                  :style="formatData.selFontStyle"
                  style="margin-bottom: 5px"
                  >{{ project.contentsOfProject }}</pre>
                <div v-if="project.dev">
                  <span style="display: inline-block; width: 100px"
                    >環境・言語</span
                  >{{ project.dev }}
                </div>
                <div v-if="project.position">
                  <span style="display: inline-block; width: 100px"
                    >役割・役職</span
                  >{{ project.position }}
                </div>
                <div v-if="project.numberOfTeam">
                  <span style="display: inline-block; width: 100px"
                    >規模・人数</span
                  >{{ project.numberOfTeam }}名
                </div>
                <div
                  v-if="
                    project.phase1 ||
                    project.phase2 ||
                    project.phase3 ||
                    project.phase4 ||
                    project.phase5 ||
                    project.phase6
                  "
                >
                  <span style="display: inline-block; width: 100px"
                    >担当工程</span
                  >
                  <span :style="phaseHighlightStyle(project.phase1)"
                    >要件定義</span
                  >
                  ／
                  <span :style="phaseHighlightStyle(project.phase2)"
                    >基本設計</span
                  >
                  ／
                  <span :style="phaseHighlightStyle(project.phase3)"
                    >詳細設計</span
                  >
                  ／
                  <span :style="phaseHighlightStyle(project.phase4)"
                    >実装・単体</span
                  >
                  ／
                  <span :style="phaseHighlightStyle(project.phase5)"
                    >結合テスト</span
                  >
                  ／
                  <span :style="phaseHighlightStyle(project.phase6)"
                    >保守・運用</span
                  >
                </div>
              </div>
            </div>
          </div>

          <h2 v-if="formatData.prMessage">自己PR</h2>
          <div
            v-if="formatData.prMessage"
            class="prMessage"
            id="pr-message"
            :data-highlight="highlightMessage"
            @click="goCardTo('pr-message')"
            :class="highLightClass('pr-message')"
          >
            <!-- <div class="label">{{ currentCardId }} {{ isCardChanged }}testtesttest</div> -->
            <pre :style="formatData.selFontStyle">{{
              formatData.prMessage
            }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useFormatPreview } from '@/composables/format-edit/useFormatPreview'
import { formatPreviewCreateDate } from '@/utils/format-edit/previewDates'
import { useHostServices } from '@/composables/format-edit/useHostServices'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const { formLib } = useHostServices()
const { scaleStyle, highlightMessage, goCardTo, highLightClass } =
  useFormatPreview(props)

const formatedCreateDate = computed(() =>
  formatPreviewCreateDate(
    props.formatData?.createDate,
    formLib.dateFormat,
    'placeholder'
  )
)

function phaseHighlightStyle(active: unknown) {
  if (!active) return undefined
  return {
    border: '1px solid #000',
    borderRadius: '5px',
    padding: '1px 2px'
  }
}

function checkValid() {}

defineExpose({ checkValid })
</script>
